import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import router from '@/router/index'

axios.tempGet = axios.get
axios.defaults.timeout = 30000
axios.get = (url, data, config) => {
  data = data || {}
  const params = data.params || data
  return axios.tempGet(url, { params: params, ...config })
}

axios.interceptors.request.use(config => {
  if (store.state.token) {
    config.headers.token = store.state.token
  }
  if (config.method === 'get') {
    for (const key in config.params) {
      if (config.params[key] === '') {
        config.params[key] = null
      }
    }
  }
  return config
}, error => {
  console.log(error)
  return Promise.reject(error)
})

axios.interceptors.response.use(response => {
  const res = response.data
  const exportUrls = [
    '/ygsjzs/ygInventory/exportYgInventoryReport',
    '/ygsjzs/yxPickupOrder/exportYxPickupOrder',
    '/ygsjzs/yxUserDeposit/exportYxDepositTransaction',
    '/ygsjzs/yxPriceOrder/exportYxPriceOrder',
    '/ygsjzs/yxUserDeposit/exportYxDepositGoods',
    '/ygsjzs/paExpenseRecord/exportPaExpenseCount',
    '/ygsjzs/paGreenEnergy/exportPaGreenEnergy',
    '/ygsjzs/ycCompanyInfo/exportYcCompanyInfo',
    '/ygsjzs/ycnPurchaseOrder/exportYcnPurchaseOrder',
    '/ygsjzs/ycnDelivery/exportYcnDelivery'
  ]
  if (exportUrls.includes(response.config.url)) {
    return response
  }
  if (res.code !== 200) {
    Message({
      message: res.message || 'Error',
      type: 'error',
      duration: 5 * 1000
    })

    if (res.code === 100000) {
      router.replace('/login')
    }
    return Promise.reject(new Error(res.message || 'Error'))
  } else {
    if (response.config.method === 'post') {
      const urls = [
        '/mclz/login',
        '/mclz/course/addCourseNum'
      ] // 排除这些接口的提示信息
      if (!urls.includes(response.config.url)) {
        Message({ type: 'success', message: res.message })
      }
    }
    return res.data
  }
}, error => {
  console.log('err' + error) // for debug
  Message({
    message: error.message,
    type: 'error',
    duration: 5 * 1000
  })
  return Promise.reject(error)
})

export default axios
